import { IS_INSTACART_BRAND } from './brand.flag'

export interface BrandLogin {
  pageBackgroundColor: string
  cardBackgroundColor: string
  cardBorderColor: string
  primaryColor: string
  secondaryColor: string
  primaryButton: { backgroundColor: string; textColor: string; borderColor: string }
  secondaryButton: { backgroundColor: string; textColor: string; borderColor: string }
  input: { backgroundColor: string; textColor: string; borderColor: string; placeholderColor: string }
  radius: { card: string; button: string; input: string }
  fontFamily: string
  logoUrl: string
}

export interface BrandChangePassword {
  illustrationUrl: string
}

export interface BrandPdf {
  poweredBy: { src: string; style: { width: string; marginTop: string } }
}

export interface BrandSplash {
  logoUrl: string
  alt: string
}

export interface Brand {
  name: 'legacy' | 'instacart'
  login: BrandLogin
  changePassword: BrandChangePassword
  pdf: BrandPdf
  splash: BrandSplash
}

const ASSETS_BUCKET_URL = 'https://odin-images-and-files-production.s3.us-east-1.amazonaws.com'
const INSTACART_ASSETS_URL = `${ASSETS_BUCKET_URL}/instacart-brand`

export const LEGACY_BRAND: Brand = {
  name: 'legacy',
  login: {
    pageBackgroundColor: '#000000',
    cardBackgroundColor: '#FFFFFF',
    cardBorderColor: '#1b474f',
    primaryColor: '#1b474f',
    secondaryColor: '#1b474f',
    primaryButton: { backgroundColor: '#29ce6c', textColor: '#FFFFFF', borderColor: '#29ce6c' },
    secondaryButton: { backgroundColor: '#ffffff', textColor: '#1b474f', borderColor: '#1b474f' },
    input: { backgroundColor: '#FFFFFF00', textColor: '#1b474f', borderColor: '#1b474f', placeholderColor: '#8296A1' },
    radius: { card: '8px', button: '4px', input: '4px' },
    fontFamily: 'Roboto',
    logoUrl: 'https://instaleap.io/wp-content/uploads/2022/10/Instaleap-Logo-1.png'
  },
  changePassword: {
    illustrationUrl: `${ASSETS_BUCKET_URL}/instaleap-auth.svg`
  },
  pdf: {
    poweredBy: { src: '/powered-by.png', style: { width: '138px', marginTop: '13px' } }
  },
  splash: {
    logoUrl: './Instaleap-logo.png',
    alt: 'Instaleap'
  }
}

const INSTACART_DARK_GREEN = '#003D29'
const INSTACART_CREAM = '#FAF1E5'

export const INSTACART_BRAND: Brand = {
  name: 'instacart',
  login: {
    pageBackgroundColor: INSTACART_DARK_GREEN,
    cardBackgroundColor: INSTACART_CREAM,
    cardBorderColor: INSTACART_CREAM,
    primaryColor: INSTACART_DARK_GREEN,
    secondaryColor: INSTACART_DARK_GREEN,
    primaryButton: { backgroundColor: INSTACART_DARK_GREEN, textColor: '#FFFFFF', borderColor: INSTACART_DARK_GREEN },
    secondaryButton: { backgroundColor: '#FFFFFF', textColor: INSTACART_DARK_GREEN, borderColor: '#FFFFFF' },
    input: {
      backgroundColor: '#FFFFFF',
      textColor: INSTACART_DARK_GREEN,
      borderColor: '#D1D4D9',
      placeholderColor: '#00000040'
    },
    radius: { card: '16px', button: '6px', input: '6px' },
    fontFamily: "'Roboto', Roboto, sans-serif",
    logoUrl: `${INSTACART_ASSETS_URL}/logo-instaleap-by-instacart.svg`
  },
  changePassword: {
    illustrationUrl: `${INSTACART_ASSETS_URL}/change-password-instacart.svg`
  },
  pdf: {
    poweredBy: { src: '/powered-by-instacart.png', style: { width: '76px', marginTop: '13px' } }
  },
  splash: {
    logoUrl: `${INSTACART_ASSETS_URL}/logo-instaleap-by-instacart.svg`,
    alt: 'Instaleap by Instacart'
  }
}

export const getBrand = (isInstacart: boolean): Brand => (isInstacart ? INSTACART_BRAND : LEGACY_BRAND)

export const BRAND = getBrand(IS_INSTACART_BRAND)
